// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_SalvaEstadoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /localidades/salvaEstado
 *
 * Creates or updates a state in the locations service.
 */
import { registerContract } from './validate'

export interface Localidades_SalvaEstadoInput {
estado_nome: string
pais_id: number
estado_id?: number
estado_sigla?: string
}

registerContract('Localidades_SalvaEstadoInput', {
  estado_nome:  { type: 'string',  required: true },
  pais_id:      { type: 'number',  required: true },
  estado_id:    { type: 'number',  required: false },
  estado_sigla: { type: 'string',  required: false },
})
